module.exports = __webpack_public_path__ + "static/prema-7d28555d2a3ca22c059583f5e7f182e1.jpg";